var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeatSauna = function SvgFeatSauna(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    viewBox: "0 0 15.124141 15.240609",
    width: 15.124142,
    height: 15.240608,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs184"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style182"
  }, ".cls-1{fill-rule:evenodd;}"))), /*#__PURE__*/React.createElement("path", {
    d: "m 4.36,1.2406084 c -0.05,-0.08 -0.14,-0.17 -0.32,-0.30000003 l 0.6,-0.80000001 c 0.21,0.16 0.43,0.34 0.58,0.58 0.16,0.26000001 0.22,0.54000004 0.22,0.87000004 0,0.22 -0.06,0.42 -0.13,0.59 -0.07,0.17 -0.16,0.33 -0.23,0.47 v 0.02 c -0.07,0.11 -0.13,0.23 -0.19,0.35 -0.05,0.11 -0.05,0.16 -0.05,0.17 0,0.14 0.03,0.24 0.08,0.33 0.05,0.09 0.15,0.19 0.32,0.32 l -0.6,0.8 c -0.23,-0.17 -0.44,-0.37 -0.58,-0.62 -0.15,-0.25 -0.22,-0.54 -0.22,-0.84 0,-0.21 0.07,-0.41 0.13,-0.57 0.06,-0.14 0.14,-0.29 0.21,-0.42 l 0.02,-0.03 c 0.07,-0.12 0.13,-0.24 0.18,-0.37 0.05,-0.11 0.06,-0.18 0.06,-0.22 0,-0.19 -0.03,-0.28 -0.07,-0.34 v 0 z m 2.5,0 c -0.05,-0.08 -0.14,-0.17 -0.32,-0.30000003 l 0.6,-0.80000001 c 0.21,0.16 0.43,0.34 0.58,0.58 0.16,0.26000001 0.23,0.54000004 0.23,0.87000004 0,0.22 -0.06,0.42 -0.13,0.59 -0.07,0.17 -0.15,0.33 -0.23,0.47 v 0.02 c -0.07,0.11 -0.13,0.23 -0.19,0.35 -0.05,0.11 -0.05,0.16 -0.05,0.17 0,0.14 0.03,0.24 0.08,0.33 0.05,0.09 0.15,0.19 0.32,0.32 l -0.6,0.8 c -0.23,-0.17 -0.44,-0.37 -0.58,-0.62 -0.15,-0.25 -0.22,-0.54 -0.22,-0.84 0,-0.21 0.07,-0.41 0.13,-0.57 0.06,-0.14 0.14,-0.29 0.21,-0.42 l 0.02,-0.03 c 0.08,-0.14 0.14,-0.26 0.18,-0.37 0.05,-0.11 0.06,-0.18 0.06,-0.22 0,-0.19 -0.03,-0.28 -0.07,-0.34 v 0 z",
    id: "path186",
    style: {
      fill: "#7f7f7f",
      fillOpacity: 1,
      stroke: "#7f7f7f",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 9.89,10.880608 0.1,-0.75 c 0.62,-0.03 1.11,-0.5399996 1.11,-1.1599996 v -0.67 c 0,-0.48 -0.29,-0.9 -0.71,-1.07 l 0.1,-0.77 c 0.09,-0.64 -0.36,-1.23 -1,-1.31 -0.05,0 -0.11,-0.01 -0.16,-0.01 H 1.86 c -0.64,0 -1.17,0.52 -1.17,1.17 0,0.05 0,0.11 0.01,0.16 l 0.1,0.77 c -0.42,0.17 -0.7,0.59 -0.7,1.06 v 0.67 c 0,0.62 0.49,1.1299996 1.11,1.1599996 l 0.54,3.99 c 0.08,0.58 0.57,1.01 1.16,1.01 H 8.1 v -0.94 c 0,0 -0.02,-0.04 -0.02,-0.06 H 7.15 l 0.33,-4 h 1.5 l -0.1,0.75 z M 9.5,6.3206084 l -0.11,0.81 H 7.73 l 0.08,-1 h 1.53 c 0.1,0 0.18,0.09 0.16,0.19 z m -2.69,-0.19 -0.08,1 H 4.48 l -0.08,-1 z m -3.42,0 0.08,1 H 1.81 l -0.11,-0.81 c -0.01,-0.09 0.05,-0.18 0.14,-0.19 0,0 0.01,0 0.02,0 z m 1.34,3.9999996 h 1.75 l -0.33,4 H 5.07 l -0.33,-4 z m -2.51,0 h 1.51 l 0.33,4 H 2.91 c -0.08,0 -0.15,-0.06 -0.16,-0.14 z M 1.27,8.1306084 c -0.09,0 -0.17,0.07 -0.17,0.17 v 0 0.67 c 0,0.09 0.08,0.17 0.17,0.17 h 8.67 c 0.09,0 0.17,-0.07 0.17,-0.17 v -0.67 c 0,-0.09 -0.07,-0.17 -0.17,-0.17 z",
    id: "path188",
    style: {
      fill: "#7f7f7f",
      fillOpacity: 1,
      stroke: "#7f7f7f",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 14.64,6.1406084 c -0.53,-0.15 -1.08,0.16 -1.24,0.69 -0.02,0.08 -0.04,0.16 -0.04,0.25 l -0.15,5.3699996 v 0.51 c 0,1.2 -0.98,2.18 -2.18,2.18 -1.2,0 -2.18,-0.98 -2.18,-2.18 v 0 -0.51 c 0,-0.28 0.22,-0.5 0.5,-0.5 h 2.88 l 0.14,-4.8899996 c 0.04,-1.3 1.29,-2.22 2.55,-1.87 l 0.08,0.02 -0.27,0.96 -0.08,-0.02 z M 12.21,12.940608 H 9.85 c 0,0.66 0.53,1.19 1.18,1.19 0.65,0 1.18,-0.53 1.18,-1.18 v 0 z",
    id: "path190",
    style: {
      fill: "#7f7f7f",
      fillOpacity: 1,
      stroke: "#7f7f7f",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }));
};
export default SvgFeatSauna;